import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "subTitle", "styles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo } from 'react';
import { H4, H3 } from "./Header.styles";
var Header = function Header(props) {
  var title = props.title,
    subTitle = props.subTitle,
    styles = props.styles,
    rest = _objectWithoutProperties(props, _excluded);
  var dataTest = rest['data-test'];
  return /*#__PURE__*/React.createElement("header", {
    "data-test": "".concat(dataTest, "header")
  }, /*#__PURE__*/React.createElement(H4, {
    "data-test": "".concat(dataTest, "title"),
    style: _objectSpread({}, styles)
  }, title), subTitle && /*#__PURE__*/React.createElement(H3, {
    "data-test": "".concat(dataTest, "subtitle")
  }, subTitle));
};
export default /*#__PURE__*/memo(Header);